export function maskEmail(email: string) {
    return email.slice(0, Math.min(email.indexOf('@'), 2)) + '***' + email.slice(email.indexOf('@'));
}
